<template>
  <div class="backendgroup-list">
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12>
          <Toolbar  :title="$t('backend_groups')"/>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <BackendGroupFilterForm
              :values="filters"
              ref="filterForm"
              slot="filter"
            />
          </DataFilter>
          <br/>
          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page.sync="options.itemsPerPage"
            :loading="isLoading"
            :loading-text="$t('Loading...')"
            :options.sync="options"
            :server-items-length="totalItems"
            @update:options="onUpdateOptions"
            class="elevation-1"
            item-key="@id"
            v-model="selected"
          >
            <ActionCell
              :handle-edit="() => editHandler(props.item)"
              slot="item.action"
              slot-scope="props"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import BackendGroupFilterForm from '../../components/backendgroup/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import ActionCell from '../../components/ActionCell';

export default {
  name: 'BackendGroupList',
  servicePrefix: 'BackendGroup',
  mixins: [ListMixin],
  components: {
    BackendGroupFilterForm,
    DataFilter,
    Toolbar,
    ActionCell,
  },
  data() {
    return {
      headers: [
        {text: this.$t('name'), value: 'name'},
        {text: this.$t('roles'), value: 'roles'},
        {
          text: this.$t('Actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: []
    };
  },
  computed: {
    ...mapGetters('backendGroup', {
      items: 'list'
    }),
    ...mapFields('backendGroup', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('backendGroup', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
